import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e058d73"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BidsForm" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_4 = { class: "mt-6 px-6 py-4 border bg-white flex flex-col" }
const _hoisted_5 = {
  key: 0,
  class: "cities"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_7 = { class: "w-full flex items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_9 = { class: "grid grid-cols-1 xl:grid-cols-2 gap-4 mt-3" }
const _hoisted_10 = { class: "border rounded p-3 grid grid-cols-1 gap-4" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Грузоотправитель", -1))
const _hoisted_12 = { class: "border rounded p-3 grid grid-cols-1 gap-4" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Грузополучатель", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-3 font-bold" }, "Характеристики груза", -1))
const _hoisted_15 = { class: "grid grid-cols-1 xl:grid-cols-2 gap-4" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-3 font-bold" }, "Данные водителя и т/с", -1))
const _hoisted_17 = { class: "flex items-center mt-2" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_19 = { class: "grid grid-cols-1 xl:grid-cols-2 gap-4 mt-2" }
const _hoisted_20 = { class: "mt-3 flex items-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_22 = { class: "grid grid-cols-1 xl:grid-cols-2 gap-4 mt-2" }
const _hoisted_23 = { class: "flex items-center justify-between mt-6" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_add_courier_modal = _resolveComponent("add-courier-modal")!
  const _component_add_car_modal = _resolveComponent("add-car-modal")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_iconRefresh = _resolveComponent("iconRefresh")!
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_checkbox = _resolveComponent("checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.courier_state.is_opened)
      ? (_openBlock(), _createBlock(_component_add_courier_modal, {
          key: 0,
          loading: _ctx.courier_state.is_loading,
          "ftl-type": _ctx.ftlBid.ftl_type,
          onCreate: _ctx.createCourier,
          onCancel: _ctx.toggleCourier,
          onSetCar: _ctx.setCar
        }, null, 8, ["loading", "ftl-type", "onCreate", "onCancel", "onSetCar"]))
      : _createCommentVNode("", true),
    (_ctx.car_state.is_opened)
      ? (_openBlock(), _createBlock(_component_add_car_modal, {
          key: 1,
          loading: _ctx.car_state.is_loading,
          onCreate: _ctx.createCar,
          onCancel: _ctx.toggleCar
        }, null, 8, ["loading", "onCreate", "onCancel"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_page_title, { title: "Создание заявки" }),
        _createVNode(_component_the_button, {
          class: "second text small",
          disabled: _ctx.state.is_loading,
          onClick: _ctx.emitCancel
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createTextVNode(" Отмена ")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_the_select, {
          placeholder: "Перевозчик",
          loading: _ctx.data_state.carriers.is_loading,
          failed: _ctx.data_state.carriers.is_failed,
          "error-text": "При получении списка перевозчиков произошла ошибка",
          options: _ctx.data_state.carriers.list,
          "is-invalid": _ctx.state_form$.carrierId.$error,
          "validation-errors": _ctx.state_form$.carrierId.$errors,
          value: _ctx.state.carrierId,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.carrierId) = $event)),
          onRefresh: _ctx.loadCarriers,
          onChange: _ctx.onCarrierChange
        }, null, 8, ["loading", "failed", "options", "is-invalid", "validation-errors", "value", "onRefresh", "onChange"]),
        (_ctx.citiesLength)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.cityIds, (city_id, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `city-${idx}`,
                  class: "cities__item"
                }, [
                  (_ctx.isAddCity(idx))
                    ? (_openBlock(), _createBlock(_component_the_button, {
                        key: 0,
                        class: "primary small my-2",
                        onClick: ($event: any) => (_ctx.addCity(idx))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_the_select, {
                      class: "cities__city",
                      placeholder: _ctx.getCityPlaceholder(idx),
                      loading: _ctx.data_state.cities.is_loading,
                      failed: _ctx.data_state.cities.is_failed,
                      "error-text": "При получении списка городов произошла ошибка",
                      options: _ctx.data_state.cities.list,
                      value: _ctx.state.cityIds[idx],
                      "onUpdate:value": ($event: any) => ((_ctx.state.cityIds[idx]) = $event),
                      "is-invalid": !_ctx.state.cityIds[idx],
                      onRefresh: _ctx.loadCities
                    }, null, 8, ["placeholder", "loading", "failed", "options", "value", "onUpdate:value", "is-invalid", "onRefresh"]),
                    (_ctx.isDelete(idx))
                      ? (_openBlock(), _createBlock(_component_the_button, {
                          key: 0,
                          class: "red small text ml-2 py-3",
                          disabled: _ctx.data_state.cities.is_loading,
                          onClick: ($event: any) => (_ctx.deleteCity(idx))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_the_select, {
              placeholder: "Компания отправитель",
              loading: _ctx.data_state.companies.is_loading,
              failed: _ctx.data_state.companies.is_failed,
              "error-text": "При получении списка произошла ошибка",
              options: _ctx.data_state.companies.list,
              "is-invalid": _ctx.state_form$.senderCompanyId.$error,
              "validation-errors": _ctx.state_form$.senderCompanyId.$errors,
              value: _ctx.state.senderCompanyId,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.senderCompanyId) = $event)),
              onRefresh: _ctx.loadCompanies
            }, null, 8, ["loading", "failed", "options", "is-invalid", "validation-errors", "value", "onRefresh"]),
            _createVNode(_component_the_input, {
              placeholder: "Адрес загрузки",
              "is-invalid": _ctx.state_form$.loadAddress.$error,
              "validation-errors": _ctx.state_form$.loadAddress.$errors,
              value: _ctx.state.loadAddress,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.loadAddress) = $event))
            }, null, 8, ["is-invalid", "validation-errors", "value"]),
            _createVNode(_component_the_input, {
              type: "date",
              placeholder: "Дата загрузки",
              "is-invalid": _ctx.state_form$.dateOfLoad.$error,
              "validation-errors": _ctx.state_form$.dateOfLoad.$errors,
              value: _ctx.state.dateOfLoad,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.dateOfLoad) = $event)),
              disabled: ""
            }, null, 8, ["is-invalid", "validation-errors", "value"]),
            _createVNode(_component_the_input, {
              placeholder: "Контактное лицо отправителя",
              "is-invalid": _ctx.state_form$.senderFullName.$error,
              "validation-errors": _ctx.state_form$.senderFullName.$errors,
              value: _ctx.state.senderFullName,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.senderFullName) = $event))
            }, null, 8, ["is-invalid", "validation-errors", "value"]),
            _createVNode(_component_the_input, {
              placeholder: "Номер отправителя",
              "is-invalid": _ctx.state_form$.senderPhoneNumber.$error,
              "validation-errors": _ctx.state_form$.senderPhoneNumber.$errors,
              value: _ctx.state.senderPhoneNumber,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.senderPhoneNumber) = $event))
            }, null, 8, ["is-invalid", "validation-errors", "value"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_the_select, {
              placeholder: "Компания получатель",
              loading: _ctx.data_state.companies.is_loading,
              failed: _ctx.data_state.companies.is_failed,
              "error-text": "При получении списка произошла ошибка",
              options: _ctx.data_state.companies.list,
              "is-invalid": _ctx.state_form$.receiverCompanyId.$error,
              "validation-errors": _ctx.state_form$.receiverCompanyId.$errors,
              value: _ctx.state.receiverCompanyId,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.receiverCompanyId) = $event)),
              onRefresh: _ctx.loadCompanies
            }, null, 8, ["loading", "failed", "options", "is-invalid", "validation-errors", "value", "onRefresh"]),
            _createVNode(_component_the_input, {
              placeholder: "Адрес разгрузки",
              "is-invalid": _ctx.state_form$.unloadAddress.$error,
              "validation-errors": _ctx.state_form$.unloadAddress.$errors,
              value: _ctx.state.unloadAddress,
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.unloadAddress) = $event))
            }, null, 8, ["is-invalid", "validation-errors", "value"]),
            _createVNode(_component_the_input, {
              type: "date",
              placeholder: "Дата разгрузки",
              "is-invalid": _ctx.state_form$.dateOfUnload.$error,
              "validation-errors": _ctx.state_form$.dateOfUnload.$errors,
              value: _ctx.state.dateOfUnload,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.dateOfUnload) = $event))
            }, null, 8, ["is-invalid", "validation-errors", "value"]),
            _createVNode(_component_the_input, {
              placeholder: "Контактное лицо получателя",
              "is-invalid": _ctx.state_form$.receiverFullName.$error,
              "validation-errors": _ctx.state_form$.receiverFullName.$errors,
              value: _ctx.state.receiverFullName,
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.receiverFullName) = $event))
            }, null, 8, ["is-invalid", "validation-errors", "value"]),
            _createVNode(_component_the_input, {
              placeholder: "Номер получателя",
              "is-invalid": _ctx.state_form$.receiverPhoneNumber.$error,
              "validation-errors": _ctx.state_form$.receiverPhoneNumber.$errors,
              value: _ctx.state.receiverPhoneNumber,
              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.receiverPhoneNumber) = $event))
            }, null, 8, ["is-invalid", "validation-errors", "value"])
          ])
        ]),
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_the_input, {
            placeholder: "Характер груза, вес, объём",
            "is-invalid": _ctx.state_form$.natureOfCargo.$error,
            "validation-errors": _ctx.state_form$.natureOfCargo.$errors,
            value: _ctx.state.natureOfCargo,
            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.natureOfCargo) = $event))
          }, null, 8, ["is-invalid", "validation-errors", "value"]),
          _createVNode(_component_the_input, {
            placeholder: "Страхование",
            "is-invalid": _ctx.state_form$.insurance.$error,
            "validation-errors": _ctx.state_form$.insurance.$errors,
            value: _ctx.state.insurance,
            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.insurance) = $event))
          }, null, 8, ["is-invalid", "validation-errors", "value"]),
          _createVNode(_component_the_input, {
            placeholder: "Тип кузова",
            "is-invalid": _ctx.state_form$.bodyType.$error,
            "validation-errors": _ctx.state_form$.bodyType.$errors,
            value: _ctx.state.bodyType,
            "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.bodyType) = $event))
          }, null, 8, ["is-invalid", "validation-errors", "value"]),
          _createVNode(_component_the_input, {
            placeholder: "Температурный режим",
            "is-invalid": _ctx.state_form$.temperatureRegime.$error,
            "validation-errors": _ctx.state_form$.temperatureRegime.$errors,
            value: _ctx.state.temperatureRegime,
            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.temperatureRegime) = $event))
          }, null, 8, ["is-invalid", "validation-errors", "value"]),
          _createVNode(_component_the_input, {
            placeholder: "Стоимость перевозки",
            value: _ctx.state.costOfTransportation,
            "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.costOfTransportation) = $event)),
            disabled: ""
          }, null, 8, ["value"]),
          _createVNode(_component_the_input, {
            placeholder: "Срок и форма оплаты",
            value: _ctx.termAndFormOfPayment,
            disabled: ""
          }, null, 8, ["value"])
        ]),
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_the_select, {
            class: "w-full mr-2",
            placeholder: "Водитель",
            loading: _ctx.data_state.couriers.is_loading,
            failed: _ctx.data_state.couriers.is_failed,
            "error-text": "При получении списка водителей произошла ошибка",
            options: _ctx.data_state.couriers.list,
            value: _ctx.state.courier_id,
            "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.courier_id) = $event)),
            "search-without-refresh": "",
            label: "fullName",
            onRefresh: _ctx.loadCouriers,
            onSearch: _ctx.searchCouriers,
            onOptionBySearch: _ctx.unshiftFindedCourier,
            onChange: _ctx.onCourierSelect,
            disabled: !_ctx.state.carrierId
          }, null, 8, ["loading", "failed", "options", "value", "onRefresh", "onSearch", "onOptionBySearch", "onChange", "disabled"]),
          _createVNode(_component_the_button, {
            class: "primary extra-small mr-2",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.loadCouriers(1))),
            loading: _ctx.data_state.couriers.is_loading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_iconRefresh)
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_the_button, {
            class: "primary extra-small",
            style: { padding: '6px 13px' },
            onClick: _ctx.toggleCourier
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode(_component_the_input, {
          class: "mt-2 w-full",
          placeholder: "ИИН",
          disabled: Boolean(_ctx.state.is_loading || _ctx.state.courier_id),
          value: _ctx.state.iin,
          "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.iin) = $event)),
          "is-invalid": _ctx.state_form$.iin.$error,
          "validation-errors": _ctx.state_form$.iin.$errors
        }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_the_input, {
            placeholder: "ФИО водителя",
            disabled: Boolean(_ctx.state.is_loading || _ctx.state.courier_id),
            value: _ctx.state.full_name,
            "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.full_name) = $event)),
            "is-invalid": _ctx.state_form$.full_name.$error,
            "validation-errors": _ctx.state_form$.full_name.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_the_input, {
            placeholder: "Телефон",
            disabled: Boolean(_ctx.state.is_loading || _ctx.state.courier_id),
            value: _ctx.state.phone_number,
            "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.phone_number) = $event)),
            "is-invalid": _ctx.state_form$.phone_number.$error,
            "validation-errors": _ctx.state_form$.phone_number.$errors,
            maska: _ctx.PHONE_NUMBER_MASK
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors", "maska"])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_the_select, {
            class: "w-full mr-2",
            placeholder: "Автомобиль",
            loading: _ctx.data_state.cars.is_loading,
            failed: _ctx.data_state.cars.is_failed,
            "error-text": "При получении списка автомобилей произошла ошибка",
            options: _ctx.data_state.cars.list,
            value: _ctx.state.carId,
            "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.carId) = $event)),
            "is-invalid": _ctx.state_form$.carId.$error,
            "validation-errors": _ctx.state_form$.carId.$errors,
            "search-without-refresh": "",
            "infinite-scroll": "",
            onRefresh: _cache[22] || (_cache[22] = ($event: any) => (_ctx.loadCars(1))),
            onLoadmore: _cache[23] || (_cache[23] = ($event: any) => (_ctx.loadMoreCars(_ctx.data_state.cars.pagination.current_page + 1))),
            onSearch: _ctx.searchCars,
            onOptionBySearch: _ctx.unshiftFindedCar,
            onChange: _ctx.onCarSelect
          }, {
            "selected-option": _withCtx(({ option }) => [
              _createTextVNode(_toDisplayString(option.model) + ", " + _toDisplayString(option.number), 1)
            ]),
            option: _withCtx(({ option }) => [
              _createTextVNode(_toDisplayString(option.model) + ", " + _toDisplayString(option.number), 1)
            ]),
            _: 1
          }, 8, ["loading", "failed", "options", "value", "is-invalid", "validation-errors", "onSearch", "onOptionBySearch", "onChange"]),
          _createVNode(_component_the_button, {
            class: "primary extra-small mr-2",
            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.loadCars(1))),
            loading: _ctx.data_state.cars.is_loading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_iconRefresh)
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_the_button, {
            class: "primary extra-small",
            style: { padding: '6px 13px' },
            onClick: _ctx.toggleCar
          }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_the_input, {
            placeholder: "Гос.номер",
            disabled: _ctx.state.is_loading || _ctx.state.carId,
            value: _ctx.state.number,
            "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.number) = $event)),
            "is-invalid": _ctx.state_form$.number.$error,
            "validation-errors": _ctx.state_form$.number.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_the_input, {
            placeholder: "Марка авто",
            disabled: _ctx.state.is_loading || _ctx.state.carId,
            value: _ctx.state.brand,
            "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.brand) = $event))
          }, null, 8, ["disabled", "value"]),
          _createVNode(_component_the_input, {
            placeholder: "Тип Т/С",
            disabled: _ctx.state.is_loading || _ctx.state.carId,
            value: _ctx.state.type,
            "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.type) = $event))
          }, null, 8, ["disabled", "value"]),
          _createVNode(_component_the_input, {
            placeholder: "ФИО Собственника Т/С",
            disabled: _ctx.state.is_loading,
            value: _ctx.state.vehicleOwnerFullName,
            "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.vehicleOwnerFullName) = $event)),
            "is-invalid": _ctx.state_form$.vehicleOwnerFullName.$error,
            "validation-errors": _ctx.state_form$.vehicleOwnerFullName.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_the_input, {
            placeholder: "Номер тех. паспорта",
            disabled: _ctx.state.is_loading,
            value: _ctx.state.technicalPassport,
            "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.state.technicalPassport) = $event))
          }, null, 8, ["disabled", "value"]),
          _createVNode(_component_the_input, {
            placeholder: "Гос. номер прицепа",
            disabled: _ctx.state.is_loading,
            value: _ctx.state.trailerLicenseNumber,
            "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state.trailerLicenseNumber) = $event))
          }, null, 8, ["disabled", "value"]),
          _createVNode(_component_the_input, {
            placeholder: "Номер удостоверения личности",
            disabled: _ctx.state.is_loading,
            value: _ctx.state.identifyCard,
            "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.identifyCard) = $event)),
            "is-invalid": _ctx.state_form$.identifyCard.$error,
            "validation-errors": _ctx.state_form$.identifyCard.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_the_input, {
            placeholder: "Номер водительского удостоверения",
            disabled: _ctx.state.is_loading,
            value: _ctx.state.licence,
            "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.state.licence) = $event)),
            "is-invalid": _ctx.state_form$.licence.$error,
            "validation-errors": _ctx.state_form$.licence.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_the_input, {
            placeholder: "Дата выдачи удостоверения личности",
            disabled: _ctx.state.is_loading,
            type: "date",
            value: _ctx.state.identifyCardDate,
            "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.state.identifyCardDate) = $event)),
            "is-invalid": _ctx.state_form$.identifyCardDate.$error,
            "validation-errors": _ctx.state_form$.identifyCardDate.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_the_input, {
            placeholder: "Дата выдачи водительского удостоверения",
            disabled: _ctx.state.is_loading,
            type: "date",
            value: _ctx.state.licenceDate,
            "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.state.licenceDate) = $event)),
            "is-invalid": _ctx.state_form$.licenceDate.$error,
            "validation-errors": _ctx.state_form$.licenceDate.$errors
          }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]),
          _createVNode(_component_file_reader, {
            placeholder: "Фото тех. паспорта",
            "is-invalid": _ctx.state_form$.carTechnicalPassportFiles.$error,
            "validation-errors": _ctx.state_form$.carTechnicalPassportFiles.$errors,
            value: _ctx.state.carTechnicalPassportFiles,
            "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.state.carTechnicalPassportFiles) = $event))
          }, null, 8, ["is-invalid", "validation-errors", "value"]),
          _createVNode(_component_checkbox, {
            value: _ctx.state.isTripartite,
            "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.state.isTripartite) = $event)),
            disabled: _ctx.state.is_loading,
            label: "Трех. стор договор",
            "return-integer": ""
          }, null, 8, ["value", "disabled"]),
          (_ctx.state.isTripartite)
            ? (_openBlock(), _createBlock(_component_the_input, {
                key: 0,
                disabled: _ctx.state.is_loading,
                placeholder: "Номер договора",
                value: _ctx.state.tripartiteNumber,
                "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.state.tripartiteNumber) = $event)),
                "is-invalid": _ctx.state_form$.tripartiteNumber.$error,
                "validation-errors": _ctx.state_form$.tripartiteNumber.$errors
              }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]))
            : _createCommentVNode("", true),
          (_ctx.state.isTripartite)
            ? (_openBlock(), _createBlock(_component_the_input, {
                key: 1,
                disabled: _ctx.state.is_loading,
                placeholder: "Дата договора",
                type: "date",
                value: _ctx.state.tripartiteDate,
                "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.state.tripartiteDate) = $event)),
                "is-invalid": _ctx.state_form$.tripartiteDate.$error,
                "validation-errors": _ctx.state_form$.tripartiteDate.$errors
              }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_the_button, {
            class: "second text small",
            disabled: _ctx.state.is_loading,
            onClick: _ctx.resetForm
          }, {
            default: _withCtx(() => [
              _hoisted_24,
              _createTextVNode(" Сбросить ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_the_button, {
            class: "primary text small",
            loading: _ctx.state.is_loading,
            onClick: _ctx.addBid
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Добавить ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ])
      ])
    ])
  ], 64))
}